import { useMemo } from 'react';
import { getBadges } from '@pkgs/components/utils/badgesUtils';

import { useDefaultSearchResultCardContext } from './SearchResultCardProvider';
import { Badge } from '../Badge/Badge';

import styles from './SearchResultCardImage.module.css';

export const SearchResultCardBadges = () => {
  const { listing, translationResolver } = useDefaultSearchResultCardContext();

  const imageDisturbers = listing.imageDisturbers;

  const badges = useMemo(
    () =>
      getBadges({
        imageDisturbers,
        translationResolver,
        countryAlpha2: listing.countryAlpha2,
        propertyMarketingType: listing.propertyMarketingType,
      }),
    [imageDisturbers, translationResolver, listing.countryAlpha2, listing.propertyMarketingType],
  );

  if (badges.length === 0) return null;

  return (
    <div className={styles.badgesContainer}>
      {badges.map(
        (badge) =>
          badge.label && (
            <Badge
              key={badge.label}
              label={badge.label}
              variant={badge.variant}
              data-testid={`search-components_result-card_badge_${badge.label}`}
            />
          ),
      )}
    </div>
  );
};
